import { render } from "./WorkflowRunner.vue?vue&type=template&id=36a4c155&scoped=true"
import script from "./WorkflowRunner.vue?vue&type=script&lang=js"
export * from "./WorkflowRunner.vue?vue&type=script&lang=js"

import "./WorkflowRunner.vue?vue&type=style&index=0&id=36a4c155&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a4c155"]])

export default __exports__